<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="()=>{getProjectListData(()=>{
                       onLoad();
                   })}"
                   @refresh-change="onLoad"
        >
          <template slot-scope="{ row }" slot="readFlag">
            <el-tag :type="row.readFlag === 1 ? 'success' : 'danger'">
              {{ row.readFlag === 0 ? '未读' : '已读' }}</el-tag
            >
          </template>
          <template slot="menu" slot-scope="scope">
            <!-- <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              v-if="permission.messagecenter_view"
              @click="clickView(scope.row)"
            >查看
            </el-button> -->
          </template>
          <template slot="projectIdSearch" slot-scope="scope">
            <div>
              <el-select
                  v-model="query.projectId"
                  placeholder="项目名称"
                  @change="projectIdChange"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in projectIdList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </div>
          </template>
          <template slot="userIdListForm" slot-scope="scope">
              <div>
                <choicePeople v-if="!viewFLag" :option="choicePeopleOption" @getPeople='getPeople'/>
                <el-input v-else v-model="form.userNames"></el-input>
              </div>
          </template>
          
          <template slot="typeIdListForm" slot-scope="scope">
              <div>
                <avue-input-tree v-if="!viewFLag" multiple :props='treeDeviceTypeProps' style="width:100%;height:32px" v-model="form.typeIdList" placeholder="设备类型" type="tree" :dic="deviceTypeList"></avue-input-tree>
                <el-input v-else v-model="form.deviceTypeNames"></el-input>
              </div>
          </template>
                  
          
        </avue-crud>
    </basic-container>
</template>

<script>
  import {getProjectList} from "@/api/crmedical/project/project";
import {
  treeByProjectDeviceTypeId_,
} from '@/api/crmedical/device/device';
    import {getDeviceRightList, saveDeviceRight, removeDeviceRight, updateDeviceRight} from"@/api/crmedical/device/deviceright";
    import {mapGetters} from "vuex";
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue'
    export default {
        components: {choicePeople},
        data: function () {
        return {
          projectIdList:[],
          viewFLag:false,
            deviceTypeList:[],
        treeDeviceTypeProps: {
            labelText: '标题',
            label: 'title',
            value: 'id',
            children: 'children',
        },
        choicePeopleOption:{
         projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'unlimitPeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
          form: {},
          query: {},
          loading: true,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          option: {
            dialogClickModal:false,
            height: 'auto',
            calcHeight: 60,
            tip: false,
            border: true,
            indexLabel:'序号',
            index: true,
            viewBtn: true,
            // delBtn: false,
            // editBtn: false,
            // addBtn: false,
            selection: true,
            // columnBtn: false,
            // refreshBtn: false,
            searchMenuSpan: 18,
            searchMenuPosition:'right',
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: "权限成员",
                prop: "userNames",
                type:'input',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: false,
                // editDisplay: false,
                // addDisplay: false,
                // viewDisplay: false,
                // hide: true,
              },
              {
                label: "设备类别",
                prop: "deviceTypeNames",
                type:'input',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: false,
                // editDisplay: false,
                // addDisplay: false,
                // viewDisplay: false,
                // hide: true,
              },
              {
                label: "权限成员",
                prop: "userIdList",
                type:'input',
                formslot:true,
                hide: true,
                // editDisplay: false,
                // addDisplay: false,
                // viewDisplay: false,
                // hide: true,
              },
              {
                label: "设备类型",
                prop: "typeIdList",
                type:'input',
                formslot:true,
                hide: true,
                // editDisplay: false,
                // addDisplay: false,
                // viewDisplay: false,
                // hide: true,
              },
              {
                label: "项目名称",
                prop: "projectId",
                type: "select",
                search: true,
                hide: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: false,
                searchslot:true,
                searchSpan:6,
                dataType: 'string',
                dicUrl: "/api/v4ward/project/getProjectList",
                props: {
                  label: "name",
                  value: "id",
                },
              },
              {
                label: "通知日期",
                prop: "notifyTime",
                type: "date",
                hide: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: false,
                format: "yyyy-MM-dd HH:mm:ss",
                valueFormat: "yyyy-MM-dd HH:mm:ss",
              },
              {
                label: "通知时间",
                prop: "releaseTimeRange",
                searchSpan:8,
                type: "datetimerange",
                showColumn:false,
                startPlaceholder:'开始时间',
                endPlaceholder:'结束时间',
                format: "yyyy-MM-dd HH:mm:ss",
                valueFormat: "yyyy-MM-dd HH:mm:ss",
                searchRange:true,
                hide: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: false,
                search: false,
                rules: [{
                  required: true,
                  message: "请输入通知时间",
                  trigger: "blur"
                }]
              },

            ]
          },
          data: []
        };
      },
      mounted(){
        this.option.height = this.bodyHeight - 380;
this.$nextTick(() => {
      setTimeout(()=>{
              document.querySelector('#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)').addEventListener("click", ()=>{

                      if(this.option.height == this.bodyHeight - 380){
                      this.option.height = this.bodyHeight - 300
                      }else{
                      this.option.height = this.bodyHeight - 380;
                      }
                      this.$refs.crud.getTableHeight();
              });
              },1000)

      });
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    viewBtn: this.vaildData(this.permission.messagecenter_view, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            },
        },
        methods: {
            projectIdChange(val){
              this.query = Object.assign({},this.query,{
                projectId:val
              })
            },
      getDeviceTypeList(value) {
      this.deviceTypeFlag = false;
      console.log("进入了")
      treeByProjectDeviceTypeId_({ projectId: value }).then((res) => {
        this.deviceTypeList = res.data;
        console.log('设备类型', this.deviceTypeList);
        this.deviceTypeFlag = true;
      });
      },
    //选人组件获取人员后赋值
    getPeople(obj){
        console.log("getPeople==========>",obj);
        let arr = [];
        obj.forEach((ele)=>{
            arr.push(ele.id);
        });
        this.form.userIdList = arr;
    //   this.ruleForm.userIds = obj.id
    },
            getProjectListData(callback){
                getProjectList().then((res)=>{
                    console.log(res);
                    this.projectIdList = res.data;
                    this.query.projectId = res.data[0].id;
                    callback();
                })
            },
          clickView(row){

            // if(row.readFlag !== 1){
            //   console.log(row.notifyUserId)
            //   updateStatus({notifyUserId:row.notifyUserId}).then(() => {
            //     this.onLoad();
            //   }, error => {
            //     console.log(error);
            //   });
            // }
          },
            rowSave(row, loading, done) {
              let self = this;
                row.projectId = self.query.projectId;
                console.log("======>rowsave=====",row);
                // return;
                if(!row.userIdList||row.userIdList.length==0){
                  this.$message.error('请选择权限成员!');
                    done();
                  return;
                }
                if(!row.typeIdList||row.typeIdList.length==0){
                  this.$message.error('请选择设备类型!');
                    done();
                  return;
                }
                let form = {
                  projectId: self.query.projectId,
                  userIdList:row.userIdList,
                  typeIdList:row.typeIdList
                }
                saveDeviceRight(form).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                if(!row.userIdList||row.userIdList.length==0){
                  this.$message.error('请选择权限成员!');
                    done();
                  return;
                }
                if(!row.typeIdList||row.typeIdList.length==0){
                  this.$message.error('请选择设备类型!');
                    done();
                  return;
                }
                updateDeviceRight(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return removeDeviceRight({id: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
              this.viewFLag = false;
              if(["add"].includes(type)){
                this.choicePeopleOption.selectList = [];
                this.form = {};
              }
              if(['view'].includes(type)){
                this.viewFLag = true;
              }
                this.choicePeopleOption.projectId = this.query.projectId;
                this.getDeviceTypeList(this.query.projectId);
                if (["edit", "view"].includes(type)) {
                  // this.form = row;
                    console.log("edit=======>",this.form);
                    let names = this.form.userNames.split('、');
                    let ids = this.form.userIds.split(',');
                    this.form.userIdList = ids;
                    let self = this;
                    this.choicePeopleOption.selectList = [];
                    names.forEach((ele,index)=>{
                        self.choicePeopleOption.selectList.push({
                            id:ids[index],
                            realName:ele,
                        })
                    })  
                    this.form.typeIdList = this.form.deviceTypeIds.split(',');
                //   if(this.form.messageSubType){
                //     this.form.messageSubType =  String(this.form.messageSubType);
                //   }
                //   if(this.form.readFlag !== 1){
                //     console.log(this.form.notifyUserId)
                //     updateStatus({notifyUserId:this.form.notifyUserId}).then(() => {
                //       this.onLoad();
                //     }, error => {
                //       done();
                //       console.log(error);
                //     });
                //   }

                    // getDetail({id:this.form.id}).then(({data}) => {
                    //     this.form = data;
                    //
                    // });
                }
                done();
            },
            searchReset() {
              let projectId = this.query.projectId;
                this.query = {projectId:projectId};
                this.onLoad();
            },
            searchChange(params,done) {
                // this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                 done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            if (this.query.releaseTimeRange) {
              this.query.timeStart = this.query.releaseTimeRange[0];
              this.query.timeEnd = this.query.releaseTimeRange[1];
              this.query.releaseTimeRange=null;
            }
            getDeviceRightList(
              Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              this.page.total = data.total;
              data.records.forEach(ele=>{
                if(!ele.businessInfo){
                  return;
                }
                let str = '';
                let temObj = JSON.parse(ele.businessInfo)
                for(let key in temObj){
                  if(key=='notifyTitle'){
                      str += temObj[key] + ' '
                    }
                   if(key!='notifyTitle'){
                      str += key +":"+temObj[key] + ' '
                    }
                }
                ele.businessInfo =str;
              })
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
            });
          }
        }
    };
</script>

<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>
